import {Pipe, PipeTransform} from '@angular/core';
import {DeviceDto} from '../../Models/Device/device.interface';
import {DeviceTypesEnum} from '../../Shared/Enum/device-types.enum';

@Pipe({
  name: 'devices',
  standalone: false
})
export class DevicesPipe implements PipeTransform {

  transform(items: DeviceDto[], filter: { menu: string, local?: number }): DeviceDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.id_local === filter.local);
    }

    switch (filter.menu) {
      case 'printers':
        items = items.filter((item) => item.id_tipo === DeviceTypesEnum.printer);
        break;

      case 'scales':
        items = items.filter((item) => item.id_tipo === DeviceTypesEnum.scale);
        break;
    }

    return items;

  }

}
